import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const authenticated = useSelector((state) => state.auth.user);

  return authenticated ? children : <Navigate to="/login" />;
};

export default ProtectedRoute;
